import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure } from "@nextui-org/react";
import { month } from "../../../../../services/enum";
import { EyeIcon } from "@heroicons/react/24/outline";

export default function ModalConsumptionDetail({ data }) {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  return (
    <>
      <Button isIconOnly size="sm" color="primary" onPress={onOpen}>
        <EyeIcon className="size-4" />
      </Button>
      <Modal size="xl" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Detail Laporan Penggunaan</ModalHeader>
              <ModalBody className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="flex flex-col">
                  <span className="text-xs text-ink-400 uppercase">Perusahaan</span>
                  <span className="text-sm font-medium">{data?.company?.name}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-ink-400 uppercase">Jenis B3</span>
                  <span className="text-sm font-medium">{data?.dataBahanB3?.namaBahanKimia}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-ink-400 uppercase">Jumlah Penggunaan</span>
                  <span className="text-sm font-medium">{data?.jumlahB3Digunakan} Kg</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-ink-400 uppercase">Periode</span>
                  <span className="text-sm font-medium">{data?.period?.name}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-ink-400 uppercase">Bulan</span>
                  <span className="text-sm font-medium">{month[data?.bulan - 1]}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-ink-400 uppercase">Tahun</span>
                  <span className="text-sm font-medium">{data?.tahun}</span>
                </div>
                <div className="flex flex-col">
                  <span className="text-xs text-ink-400 uppercase">Peruntukan Penggunaan</span>
                  <span className="text-sm font-medium">{data?.peruntukanPenggunaan || "-"}</span>
                </div>
              </ModalBody>
              <ModalFooter></ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
